import { createReducer } from '@reduxjs/toolkit';
import { IOrgDashboardState } from './types';
import { fetchOrgSummary, fetchOrgShiftRequests, fetchOrgWeeklyActivity, fetchOrgPlan } from './actions';

const initialState: IOrgDashboardState = {
  loading: {
    summary: false,
    shiftRequests: false,
    weeklyActivity: false,
    plan: false,
  },
  data: {
    summary: null,
    shiftRequests: null,
    weeklyActivity: null,
    plan: null,
  },
  error: null,
};

export const orgDashboardReducer = createReducer(initialState, (builder) => {
  builder
    // Summary
    .addCase(fetchOrgSummary.pending, (state) => {
      state.loading.summary = true;
    })
    .addCase(fetchOrgSummary.fulfilled, (state, action) => {
      state.loading.summary = false;
      state.data.summary = action.payload;
    })
    .addCase(fetchOrgSummary.rejected, (state, action) => {
      state.loading.summary = false;
      state.error = action.payload as string;
    })
    // Shift Requests
    .addCase(fetchOrgShiftRequests.pending, (state) => {
      state.loading.shiftRequests = true;
    })
    .addCase(fetchOrgShiftRequests.fulfilled, (state, action) => {
      state.loading.shiftRequests = false;
      state.data.shiftRequests = action.payload;
    })
    .addCase(fetchOrgShiftRequests.rejected, (state, action) => {
      state.loading.shiftRequests = false;
      state.error = action.payload as string;
    })
    // Weekly Activity
    .addCase(fetchOrgWeeklyActivity.pending, (state) => {
      state.loading.weeklyActivity = true;
    })
    .addCase(fetchOrgWeeklyActivity.fulfilled, (state, action) => {
      state.loading.weeklyActivity = false;
      state.data.weeklyActivity = action.payload;
    })
    .addCase(fetchOrgWeeklyActivity.rejected, (state, action) => {
      state.loading.weeklyActivity = false;
      state.error = action.payload as string;
    })
    // Plan
    .addCase(fetchOrgPlan.pending, (state) => {
      state.loading.plan = true;
    })
    .addCase(fetchOrgPlan.fulfilled, (state, action) => {
      state.loading.plan = false;
      state.data.plan = action.payload;
    })
    .addCase(fetchOrgPlan.rejected, (state, action) => {
      state.loading.plan = false;
      state.error = action.payload as string;
    });
});
